import React from "react";
import { Container, Typography, Box, Paper, Stack } from "@mui/material";
import { Phone, Email } from "@mui/icons-material";

const ContactUs = () => {
    return (
        <Container maxWidth="md">
            <Box mt={5} p={4} component={Paper} elevation={3} borderRadius={2}>
                {/* Page Title */}
                <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: "bold", color: "primary.main" }}>
                    Contact Us
                </Typography>

                {/* Legal Name Section */}
                <Box mt={4} textAlign="center">
                    <Typography variant="h6" gutterBottom sx={{ fontWeight: "medium", color: "text.primary" }}>
                        Legal Name:
                    </Typography>
                    <Typography variant="body1" color="textSecondary" sx={{ fontSize: "1.1rem" }}>
                        SANJAY VYAS VISHWAKARMA
                    </Typography>
                </Box>

                {/* Address Section */}
                <Box mt={4} textAlign="center">
                    <Typography variant="h6" gutterBottom sx={{ fontWeight: "medium", color: "text.primary" }}>
                        Address:
                    </Typography>
                    <Typography variant="body1" color="textSecondary" sx={{ fontSize: "1.1rem" }}>
                         Appapada, Kurar Village, Malad East, Mumbai - 400097
                    </Typography>
                </Box>

                {/* Contact Details Section */}
                <Stack spacing={4} mt={5} direction={{ xs: "column", sm: "row" }} justifyContent="center" alignItems="center">
                    {/* Phone Number */}
                    <Box textAlign="center" sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Phone color="primary" fontSize="large" sx={{ mb: 1 }} />
                        <Typography variant="body1" sx={{ fontSize: "1.1rem", color: "text.primary" }}>
                            +91 95940 13627
                        </Typography>
                    </Box>

                    {/* Email */}
                    <Box textAlign="center" sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Email color="primary" fontSize="large" sx={{ mb: 1 }} />
                        <Typography variant="body1" sx={{ fontSize: "1.1rem", color: "text.primary" }}>
                            hifi785@gmail.com
                        </Typography>
                    </Box>
                </Stack>
            </Box>
        </Container>
    );
};

export default ContactUs;